import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoCalendar = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Calendar</title>
    <path
      d="M5.57 11.276v12.57a3.43 3.43 0 0 0 3.429 3.43h16a3.429 3.429 0 0 0 3.428-3.429v-12.57a3.429 3.429 0 0 0-3.429-3.43h-16a3.429 3.429 0 0 0-3.428 3.429ZM21.571 5.562v4.57M12.428 5.562v4.57M5.57 14.706h22.857"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoCalendar;
